export default "__VITE_ASSET__DJGHDZ_8__"